module.exports = __webpack_public_path__ + "829607717cf21434ac79cdd77b44b75d.svg";